export default __webpack_public_path__ + "static/media/DOWNLOAD.c7f5317d.svg";